var storefrontApp = angular.module('storefrontApp');
storefrontApp.service('membershipService', ['$http', function ($http) {
    return {
        getGoodiesContent: function () {
            return $http.get('storefrontapi/club/goodiescontent');
        },
        getPageContent: function () {
            return $http.get('storefrontapi/club/clubpagecontent');
        },
        getMembershipPlans: function () {
            return $http.get('storefrontapi/club/membershipplans');
        },
        getMembershipPaymentMethods: function () {
            return $http.get('storefrontapi/club/getclubpaymentmethods');
        },
        placeMembershipOrder: function (ccId, billAddrId, cvv, planId, planTenure, planName, planPrice) {
            return $http.post(
                "storefrontapi/club/placetrialmembershiporder", { CreditCardId: ccId, BillingAddressId: billAddrId, CVVNumber: cvv, PlanId: planId, PlanTenure: planTenure, PlanName: planName, PlanPrice: planPrice }
            );
        },
        getCountries: function () {
            return $http.get('storefrontapi/countries?t=' + new Date().getTime());
        },
        getCountryRegions: function (countryCode) {
        	return $http.get('storefrontapi/countries/' + countryCode + '/regions?t=' + new Date().getTime());
        },
        getCustomerMembershipDetails: function (userId) {
            return $http.get('storefrontapi/club/membershipinfo?userId=' + userId);
        },
    }
}]);
